<template>
  <div>
    <b-container class="text-left">
      <b-row class="mt-1 justify-content-between">
        <b-col cols="3" class="data-container-mq circle-logout-container-mq">
          <b-row class="ml-1">
            <b-avatar variant="secondary" :src="imageSrc" class="avatar-bg">
              <div v-if="!imageSrc" style="font-size: 3em">
                {{
                  this.getUser.fullName
                    .split(' ')
                    .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
                    .join('')
                }}
              </div>
            </b-avatar>
          </b-row>
          <b-row class="ml-1 logout-button-mq">
            <b-button variant="primary" class="mt-2" style="min-width: 170px;" v-on:click="handleLogout"
              >Kijelentkezés</b-button
            >
          </b-row>
        </b-col>
        <b-col cols="7" class="data-container-mq">
          <h2>Személyes adatok</h2>
          <div class="justify-content-between">
            <b-row>
              <b-row cols="2" class="ml-1 mr-1 profile-details">
                <b-col class="col-6">Teljes név</b-col>
                <b-col class="col-6">{{ this.getUser.fullName }}</b-col>
                <b-col class="col-6">Felhasználónév</b-col>
                <b-col class="col-6">{{ this.getUser.userName }}</b-col>
                <b-col class="col-6">Telefonszám</b-col>
                <b-col class="col-6">{{ this.getUser.phoneNumber }}</b-col>
                <b-col class="col-6">Email cím</b-col>
                <b-col class="col-6"> {{ this.getUser.email }}</b-col>
              </b-row>
            </b-row>
            <b-row class="col-12 col-lg-4 col-md-4 col-sm-4 edit-button">
              <b-button variant="secondary" class="button-mq" v-on:click="showProfileEditModal">
                Adatok szerkesztése
              </b-button>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          xs="12"
          sm="12"
          md="12"
          lg="9"
          xl="9"
          offset-xs="0"
          offset-md="0"
          offset-sm="0"
          offset-lg="3"
          offset-xl="3"
          class="mt-4 mb-5"
        >
          <hr />
          <h2 class="text-left mt-3 mb-4">Vállalkozásaim listája</h2>
          <section
            v-if="
              userSoleProprietorships.length > 0 || userCompanies.length > 0 || this.imaginaryUserCompanies.length > 0
            "
          >
            <b-row v-if="userSoleProprietorships.length > 0" class="mb-5">
              <b-col>
                <p class="businesses-subtitle">Egyéni vállalkozások</p>
                <div
                  v-for="userSoleProprietorship in userSoleProprietorships"
                  :key="userSoleProprietorship.id"
                  class="row companybox-holder rounded m-1 mr-2 mb-2 mt-4"
                >
                  <b-row class="col-11 business-box">
                    <div class="company-name">
                      <a @click.prevent="redirectToSoleProprietorshipDetails(userSoleProprietorship)">{{
                        getTitleCaseString(userSoleProprietorship.soleProprietorshipData.name)
                      }}</a>
                    </div>
                    <div class="mt-2">
                      <p class="position-title">{{ userSoleProprietorship.position | mapPosition }}</p>
                    </div>
                  </b-row>
                  <div class="col-1 deleteCompanyColumn cursor-pointer">
                    <trash-svg
                      v-on:click.native="
                        showConfirmDeleteSoleProprietorship(
                          userSoleProprietorship.id,
                          userSoleProprietorship.soleProprietorshipData
                        )
                      "
                      class="company-control"
                    ></trash-svg>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="userCompanies.length > 0" class="mb-5">
              <b-col>
                <p class="businesses-subtitle">Társas vállalkozások</p>
                <div
                  v-for="userCompany in userCompanies"
                  :key="userCompany.id"
                  class="row companybox-holder rounded m-1 mr-2 mb-2 mt-4"
                >
                  <b-row class="col-11 business-box">
                    <div class="company-name">
                      <a @click.prevent="redirectToDetails(userCompany)">{{
                        userCompany.companyData.long_name[0].name
                      }}</a>
                    </div>
                    <div class="mt-2">
                      <p class="position-title">{{ userCompany.position | mapPosition }}</p>
                    </div>
                  </b-row>
                  <div class="col-1 deleteCompanyColumn cursor-pointer">
                    <trash-svg
                      v-on:click.native="showConfirmDelete(userCompany.id, userCompany.companyData)"
                      class="company-control"
                    ></trash-svg>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="this.imaginaryUserCompanies.length > 0">
              <b-col>
                <p class="businesses-subtitle">Tervezett vállalkozások</p>
                <div
                  v-for="userCompany in this.imaginaryUserCompanies"
                  :key="userCompany.companyId"
                  class="row companybox-holder rounded m-1 mr-2 mb-2 mt-4"
                >
                  <b-row class="col-10 business-box">
                    <div class="company-name">
                      <a @click.prevent="redirectToImagiaryCompanyDetails(userCompany)">{{
                        userCompany.companyData.name
                      }}</a>
                    </div>
                    <div class="mt-2">
                      <p class="position-title">{{ userCompany.position | mapPosition }}</p>
                    </div>
                  </b-row>
                  <div class="col-1 deleteCompanyColumn cursor-pointer" style="margin-left: -10px">
                    <font-awesome-icon
                      @click="goToEditImaginaryCompany(userCompany)"
                      icon="fa-solid fa-pen"
                      class="badge"
                    />
                  </div>
                  <div class="col-1 deleteCompanyColumn cursor-pointer" style="margin-left: 10px">
                    <trash-svg
                      v-on:click.native="showConfirmDeleteImaginaryCompany(userCompany._id)"
                      class="company-control"
                    ></trash-svg>
                  </div>
                </div>
              </b-col>
            </b-row>
          </section>

          <section v-else class="d-flex no-company-container">
            <div class="col-6 d-flex align-items-center justify-content-center">
              <p class="no-company-text">Még nincsenek lehetőségek elmentve a kedvencek közé!</p>
            </div>
            <div class="col-6">
              <img
                src="../assets/img/user-profile-no-company.png"
                alt="favourites-background"
                class="no-company-background-image"
              />
            </div>
          </section>
          <b-button variant="primary" class="mt-5 add-company-button" @click="showCompanySearchModal">
            + Új vállalkozás hozzáadása
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <b-modal size="lg" ref="profile-company-search-modal" id="profile-company-search-modal" hide-footer>
      <div class="d-block text-left pr-3 pl-3 pt-0 mb-4">
        <h1>Keressen meg még egy, Önhöz tartozó céget!</h1>
        <br />
        <ifka-vp-search-company />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchCompany from '@/components/SearchCompany.vue'
import handleLogout from '../mixins/HandleLogout'
import TrashSvg from '../components/svg/Trash'
import * as ImaginaryCompanyApi from '../api/imaginaryCompany'
import * as ImaginaryUserCompanyApi from '../api/imaginaryUserCompany'

export default {
  name: 'Profile',
  mixins: [handleLogout],
  data() {
    return {
      file1: null,
      profileModify: {
        fullName: '',
        userName: '',
        phoneNumber: ''
      },
      imaginaryUserCompanies: []
    }
  },
  filters: {
    mapPosition: function(position) {
      switch (position) {
        case 'OWNER':
          return 'Tulajdonos'
        case 'COMPANY_MANAGER':
          return 'Cégvezető'
        case 'SENIOR_OFFICER':
          return 'Vezető tisztségviselő'
        case 'ACCOUNTANT':
          return 'Könyvelő'
        case 'APPLICATION_WRITER':
          return 'Pályázatíró'
        case 'CONSULTANT':
          return 'Tanácsadó'
        case 'SOLE_PROPRIETORSHIP':
          return 'Vállalkozó'
        default:
          return ''
      }
    }
  },
  components: {
    ifkaVpSearchCompany: SearchCompany,
    TrashSvg
  },
  computed: {
    ...mapGetters(['getUser', 'userCompanies', 'userSoleProprietorships', 'isLoading']),
    imageSrc() {
      return this.getUser.imageName
        ? `${window._env_.VUE_APP_API_URL}/api/v1/image/${this.getUser.imageName}`
        : undefined
    }
  },
  methods: {
    nullifyCompanyAttributeObject(key) {
      this.$store.dispatch('nullifyCompanyAttributeObjectAction', key)
    },
    nullifyFundMapCategory(key) {
      this.$store.dispatch('nullifyFundMapCategoryAction', key)
    },
    async uploadImage() {
      const formData = new FormData()
      formData.append('file', this.file1)
      await this.$store.dispatch('createImage', formData)
    },
    async onDeleteClick(userCompanyId) {
      await this.$store.dispatch('deleteUserCompany', { userCompanyId })
      const getParams = {}
      await this.$store.dispatch('getUserCompanies', getParams)
      await this.$store.dispatch('getUserSoleProprietorships', getParams)
    },
    async onDeleteSoleProprietorshipClick(soleProprietorshipId) {
      await this.$store.dispatch('deleteUserSoleProprietorship', { soleProprietorshipId })
      const getParams = {}
      await this.$store.dispatch('getUserSoleProprietorships', getParams)
    },
    async showConfirmDelete(userCompanyId, companyData) {
      let companyName, confirmText
      if (companyData.short_name[0]) {
        companyName = companyData.short_name[0].name
        confirmText = 'Biztos, hogy törölni szeretné a(z) ' + companyName + '-t?'
      } else if (companyData.long_name[0] && !companyData.short_name[0]) {
        companyName = companyData.long_name[0].name
        confirmText = 'Biztos, hogy törölni szeretné a(z) ' + companyName + '-t?'
      } else {
        confirmText = 'Biztos, hogy törli a céget?'
      }
      const h = this.$createElement
      const titleVNode = h('div', { domProps: { innerHTML: `<h1 class="p-4">${confirmText}</h1>` } })
      await this.$bvModal
        .msgBoxConfirm([titleVNode], {
          title: '',
          size: 'lg',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Igen',
          cancelTitle: 'Nem',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          id: 'delete-company-modal'
        })
        .then(value => {
          if (value == true) this.onDeleteClick(userCompanyId)
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    async showConfirmDeleteSoleProprietorship(soleProprietorshipId, soleProprietorshipData) {
      let soleProprietorshipName, confirmText
      if (soleProprietorshipData.name) {
        soleProprietorshipName = this.getTitleCaseString(soleProprietorshipData.name)
        confirmText = 'Biztos, hogy törölni szeretné a(z) ' + soleProprietorshipName + ' vállalkozását?'
      } else {
        confirmText = 'Biztos, hogy törli a vállalkozást?'
      }
      const h = this.$createElement
      const titleVNode = h('div', { domProps: { innerHTML: `<h1 class="p-4">${confirmText}</h1>` } })

      await this.$bvModal
        .msgBoxConfirm([titleVNode], {
          title: '',
          size: 'lg',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Igen',
          cancelTitle: 'Nem',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          id: 'delete-company-modal'
        })
        .then(value => {
          if (value == true) this.onDeleteSoleProprietorshipClick(soleProprietorshipId)
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    showCompanySearchModal() {
      this.$refs['profile-company-search-modal'].show()
    },
    hideCompanySearchModal() {
      this.$refs['profile-company-search-modal'].hide()
    },
    showProfileEditModal() {
      //this.$refs['profile-modify-profile-data'].show()
      this.$router.push('/profile-edit')
    },
    hideProfileEditModal() {
      this.$refs['profile-modify-profile-data'].hide()
    },
    async selectUserCompany(selectedUserCompany) {
      const getCompanyQueryParams = { value: selectedUserCompany.companyId }
      await this.$store.dispatch('getCompany', getCompanyQueryParams)
      this.$store.commit('setSelectedUserCompany', selectedUserCompany)
      this.$router.push('company-offers-private')
    },
    async redirectToDetails(selectedUserCompany) {
      const getCompanyQueryParams = { value: selectedUserCompany.companyId }
      await this.$store.dispatch('getCompany', getCompanyQueryParams)
      this.$store.commit('setSelectedUserCompany', selectedUserCompany)
      this.$router.push({
        name: 'CompanyDetails'
      })
    },
    async redirectToSoleProprietorshipDetails(selectedUserSoleProprietorship) {
      const getCompanyQueryParams = { value: selectedUserSoleProprietorship.soleProprietorshipData.flaggerId }
      await this.$store.dispatch('getSoleProprietorship', getCompanyQueryParams)
      this.$store.commit('setSelectedSoleProprietorship', selectedUserSoleProprietorship.soleProprietorshipData)
      this.$router.push({
        name: 'SoleProprietorshipDetails'
      })
    },
    getTitleCaseString(item) {
      return item
        .split(' ')
        .map(name => {
          const lowerCaseName = name.toLowerCase()
          return lowerCaseName.charAt(0).toUpperCase() + lowerCaseName.slice(1)
        })
        .join(' ')
    },
    async showConfirmDeleteImaginaryCompany(userCompanyId) {
      const confirmText = 'Biztos, hogy törölni szeretné a tervezett vállalkozást?'
      const h = this.$createElement
      const titleVNode = h('div', { domProps: { innerHTML: `<h1 class="p-4">${confirmText}</h1>` } })
      await this.$bvModal
        .msgBoxConfirm([titleVNode], {
          title: '',
          size: 'lg',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Igen',
          cancelTitle: 'Nem',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          id: 'delete-company-modal'
        })
        .then(value => {
          if (value == true) {
            this.deleteImaginaryUserCompany(userCompanyId)
            this.deleteImaginaryCompany(userCompanyId)
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    async deleteImaginaryUserCompany(userCompanyId) {
      await ImaginaryUserCompanyApi.deleteImaginaryUserCompanyById(userCompanyId)
    },
    async deleteImaginaryCompany(userCompanyId) {
      const imaginaryCompany = this.imaginaryUserCompanies.find(userCompany => userCompany._id === userCompanyId)
      await ImaginaryCompanyApi.deleteImaginaryCompanyById(imaginaryCompany.companyId)

      this.getImaginaryUserCompanyByUserId(this.getUser._id)
    },
    goToEditImaginaryCompany(userCompany) {
      this.addCompany('imaginaryCompany', {
        companyData: userCompany.companyData,
        companyId: userCompany.companyId,
        _id: userCompany._id
      })
      this.$router.push({
        name: 'FundMapCreateImaginaryCompany'
      })
    },
    addCompany(key, value) {
      this.$store.dispatch('setFundMapCompanyAction', { [key]: value })
    },
    redirectToImagiaryCompanyDetails(userCompany) {
      this.addCompany('imaginaryCompany', { companyData: userCompany.companyData, companyId: userCompany.companyId })
      this.$router.push({
        name: 'FundMapImaginaryCompanyDetails'
      })
    },
    async getImaginaryUserCompanyByUserId(userId) {
      try {
        this.imaginaryUserCompanies = await ImaginaryUserCompanyApi.getImaginaryUserCompanyByUserId(userId)
      } catch (e) {
        console.log(e)
      }
    }
  },
  async created() {
    this.nullifyCompanyAttributeObject({})
    this.nullifyFundMapCategory({})
    this.$store.dispatch('resetStepsAction')
    this.$gtag.event('profile', {
      event_category: 'user_interaction'
    })

    await this.$store.dispatch('getUserCompanies', {})
    await this.$store.dispatch('getUserSoleProprietorships', {})
    this.getImaginaryUserCompanyByUserId(this.getUser._id)
  }
}
</script>

<style scoped>
.profile-picture {
  width: 150px;
  height: 150px;
}

.profile-details > .col {
  margin-top: 20px;
  text-align: left;
  min-width: auto;
}

.profile-details {
  max-width: 400px;
}

.profile-details > .col:nth-child(odd) {
  color: var(--color-green);
  font-weight: bold;
  text-align: left;
}

.companybox-holder {
  padding: 20px;
  -webkit-box-shadow: 0px 0px 9px 5px rgba(235, 235, 235, 1);
  -moz-box-shadow: 0px 0px 9px 5px rgba(235, 235, 235, 1);
  box-shadow: 0px 0px 9px 5px rgba(235, 235, 235, 1);
}

.company-name {
  color: var(--color-green);
  font-weight: bold;
  cursor: pointer;
}

.company-control {
  color: var(--color-red) !important;
  font-weight: bold;
  border: 0px;
  background: transparent;
  width: 20px;
  font-size: 18px;
}

.deleteCompanyColumn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.business-box {
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.businesses-subtitle {
  padding-left: 5px;
  font-weight: bold;
  color: #636e72;
}

.position-title {
  margin: 0;
  color: #636e72;
}

.avatar-bg {
  min-width: 170px;
  min-height: 170px;
  background: #b2bec3;
}

.badge {
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  color: #00903c;
}

@media (max-width: 993px) {
  .add-company-button {
    width: 95%;
    margin-left: 5px;
  }
}

.no-company-container {
  padding: 20px;
  padding-top: 30px;
  min-height: 80px;
  background-color: #f7fbfc;
  min-height: 80px;
  margin-bottom: 10px;
}

.no-company-background-image {
  width: 100%;
}
.no-company-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  color: #00903c;
  max-width: 300px;
}

@media (max-width: 992px) {
  .no-company-text {
    font-size: 16px;
  }
}

.edit-button {
  margin-top: 15px;
  min-width: fit-content;
}
@media (min-width: 992px) {
  .edit-button {
    position: absolute;
    bottom: 0px;
    right: 0px;
    margin-top: 0px;
    width: auto;
  }
}

@media (max-width: 577px) {
  .data-container-mq {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 10px;
  }
}
@media (max-width: 391px) {
  .circle-logout-container-mq {
    display: flex;
  }
  .avatar-bg {
    min-height: 75px;
    min-width: 75px;
  }
  .logout-button-mq {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 75%;
  }

  .button-mq {
    min-width: 100%;
  }
  .edit-button {
    margin: 0 auto !important;
    margin-top: 15px !important;
  }
}
</style>
